import {
  faFacebookF,
  faWhatsapp,
  faLinkedinIn,
  faInstagram,
  // faTwitter,
  // faYoutube,
} from "@fortawesome/free-brands-svg-icons";

export const socialIcons = [
  {
    iconName: faFacebookF,
    link: "https://www.facebook.com/",
  },
  // {
  //   iconName: faTwitter,
  //   link: "https://twitter.com/",
  // },
  {
    iconName: faWhatsapp,
    link: "https://api.whatsapp.com/send?phone=923121088139&text=Hi!%20my%20name%20is%20%5Bname%5D.%20I%20want%20to%20know%20more%20about%20website%20or%20mobile%20app.",
  },
  {
    iconName: faLinkedinIn,
    link: "https://www.linkedin.com/",
  },
  // {
  //   iconName: faYoutube,
  //   link: "https://www.youtube.com/",
  // },
  {
    iconName: faInstagram,
    link: "https://www.instagram.com/",
  },
];
